var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: {
      scrollable: "",
      "has-header": "",
      "has-footer": "",
      open: _vm.isOpen,
      size: "large",
    },
    on: { close: _vm.onClose },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "h2",
              { staticClass: "emd-text _size_section _color_contrast" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("modal.boleto-stone.modal-fail-habilitation.title")
                    ) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _color_subtle" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "modal.boleto-stone.modal-fail-habilitation.paragraph-1"
                    )
                  ) +
                  " "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "emd-button",
              {
                staticClass: "emd-btn _size_big _block",
                attrs: { color: "primary", size: "big", block: true },
                on: { click: _vm.onClose },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "modal.boleto-stone.modal-fail-habilitation.button-ok"
                      )
                    ) +
                    " "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }